import byIdMaker from 'reducersMakers/byIdMaker';
import * as actions from 'actions';

export default byIdMaker({
  fetchSuccessTypes: [ actions.JOURNAL_ENTRIES_FETCH_SUCCESS ],
  entityType: 'journalEntries'
});



/** WEBPACK FOOTER **
 ** ./src/members/state/journal/byId/reducer.js
 **/